<template>
  <div class="header">
    <div class="logo">
		<div class="topbg">
			
		</div>
	</div>

    <div class="title ">
      <div
        class="item hover hand"
        v-for="(item, index) in list"
        :key="index"
        :class="curr == index ? 'act' : ''"
        @click="navFun(item.url)"
      >
        {{ item.title }}
        <div class="icon" v-show="curr == index"></div>
		
		<!-- <div class="blackcon" style="" v-show="index == 5"></div> -->
      </div>
	  
    </div>
	
	
  </div>
</template>

<script>
export default {
  props: {
    curr: {
      type: String || Number,
      default: "0"
    }
  },
  components: {},
  data: function() {
    return {
      //               捐助项目
      list: [
        { title: "首页", url: "/" },
        { title: "捐助项目", url: "/project" },
        { title: "捐助排行", url: "/ranking" },
        // { title: "捐助记录", url: "/about" }
        { title: "公示公告", url: "/notice" },
		{ title: "信息公开", url: "/informatedisclosure" },
		{ title: "政策法规", url: "/policiesregulations" },
		{ title: "公益活动", url: "/benefitactivities" },
		{ title: "机构展示", url: "/Institutional" },
      ]
    };
  },
  mounted() {
    // this.makeCode(this.identifyCodes, 4);
  },
  created() {},

  methods: {
    navFun(e) {
		// console.log(this.$route.path+"---------")
		if(this.$route.path == e){
			this.$router.go(0)
		}else{
			this.$router.push({ path: e, query: {} });
		}
     	  
    },
	refreshagain(){
		this.$router.go(0)
	},
  }
};
</script>

<style scoped="scoped" lang="scss">
.header {
  width: 100%;
  height: 0.97rem;
  // background: #e61f26;
  position: relative;
  z-index: 10;
  // display: flex;
  // justify-content: center;
  .logo {
    // position: absolute;
    width: 3.72rem;
    height: 2.27rem;
    margin: 0.32rem 3.82rem;
    
	.topbg{
		position: absolute;
		margin-top: 0.2rem;
		height: 1.38rem;
		width: 3.92rem;
		background: url(../assets/top_imgbg.png) no-repeat center / 100% 100%;
	}
  }
  .title {
    margin: 0auto;
    width: 100%;
    // overflow: hidden;
    height: 0.6rem;
    line-height: 0.6rem;
    background: #e41e15;
    text-align: center;
    // position: absolute;
    .item {
      // float: left;
      display: inline-block;
      width: auto;
      min-width: 0.69rem;
      // overflow: hidden;
      // height: 0.97rem;
      // line-height: 0.97rem;
      margin-right: 0.75rem;
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      opacity: 0.8;
      position: relative;
      .icon {
        width: 100%;
        bottom: 0.01rem;
        left: 0;
        // margin-left: -0.09rem;
        position: absolute;
        background: #ffffff;
        border-width: 0.03rem;
        border-style: solid;
        // border-color: #e61f26 #e61f26 #ffffff #e61f26;
      }
	  
	  // .blackcon{
			// left: 0;
			// position: absolute; 
			// z-index: 100;
			// width: 1.5rem;
			// height:150px;
			// background: #FFFFFF;
			// border: 1px solid blue;  
	  // }
	  
    }
    .act {
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>
